import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Label, Typography } from '@pocketlaw/tetris';
import { useFormikContext } from 'formik';
import { useEsigningProviderMetadata } from 'app/domains/esigning/hooks/useEsigningProviderMetadata';
import { EsigningProviderAuthenticationModeSlug, EsigningRecipientType } from 'shared/domains/apollo/generated/types';
import { TextField } from 'shared/domains/forms';
import { PhoneNumberField } from 'shared/domains/forms/components/PhoneNumberField';
import { RoleAndAuth } from './RoleAndAuth';
import { ColumnsContainer, FieldWrapper, LeftColumn, RightColumn } from './styled';
export function Content() {
    const { values: formValues } = useFormikContext();
    const { type, authenticationMode } = formValues;
    const { properties: metadataProperties } = useEsigningProviderMetadata();
    const { canUseTitleField } = metadataProperties;
    const isSigning = type === EsigningRecipientType.Signatory;
    const isApprover = type === EsigningRecipientType.Approver;
    const showTitleField = (isSigning || isApprover) && canUseTitleField;
    const showMobileField = isSigning && authenticationMode === EsigningProviderAuthenticationModeSlug.SmsOtp;
    const optionalFieldDescription = t({
        comment: 'eSigning recipient form field - Optional field text',
        message: 'If applicable',
    });
    return (<ColumnsContainer>
      <LeftColumn>
        <div style={{ position: 'relative' }}>
          <Label>
            <Trans comment="Label for the add/edit eSigning recipient details">Add details for recipients</Trans>
          </Label>
        </div>
        <Typography $appearance="100" $fontSize="small">
          <Trans comment="Message for the add/edit eSigning recipient details">
            Signers will be able to sign the document. Viewers will receive a copy once it&apos;s signed. You can also
            select and manage contacts under the Contact library tab.
          </Trans>
        </Typography>
      </LeftColumn>
      <RightColumn>
        <FieldWrapper>
          <TextField name="firstName" label={t({
            comment: 'eSigning recipient form field - First name',
            message: 'First name',
        })}/>
        </FieldWrapper>
        <FieldWrapper>
          <TextField name="lastName" label={t({ comment: 'eSigning recipient form field - Last name', message: 'Last name' })}/>
        </FieldWrapper>
        <FieldWrapper>
          <TextField name="email" label={t({ comment: 'eSigning recipient form field - Email', message: 'Email' })}/>
        </FieldWrapper>
        {showTitleField && (<FieldWrapper>
            <TextField name="title" label={t({ comment: 'eSigning recipient form field - Title', message: 'Title' })} description={optionalFieldDescription}/>
          </FieldWrapper>)}
        <FieldWrapper>
          <TextField name="label" label={t({ comment: 'eSigning recipient form field - Company', message: 'Company' })} description={optionalFieldDescription}/>
        </FieldWrapper>
        <RoleAndAuth />
        {showMobileField && (<PhoneNumberField stretch name="mobile" label={t({
                comment: 'eSigning recipient form field - Phone number',
                message: 'Phone number',
            })}/>)}
      </RightColumn>
    </ColumnsContainer>);
}
